import { handleSessionTermination, isSessionTerminated } from './apiClient';

// Wraps an RTK Query baseQuery so a session-ending 403 (displaced / expired /
// maintenance) logs the user out exactly like requests made through apiClient,
// instead of surfacing as an ordinary query error.
export const withSessionTermination =
  (baseQuery) => async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (
      result?.error &&
      isSessionTerminated(result.error.status, result.error.data)
    ) {
      return handleSessionTermination(result.error.data);
    }
    return result;
  };
